module.exports = "/images/eoi_background_img.jpg?d52837616b1c8d0e4b2f9f15795d0f87";